import React, { useEffect, useState } from 'react'
import { GridColDef } from '@mui/x-data-grid';
import { PAGESIZE } from '../../../../utils/constants';
import { FieldErrors } from '../../../../domain/helpers/Errors';
import { validateSchema } from '../../../../common/ValidateSchema';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { VendorStatusInterface } from '../../../../models/ProcurementModule/VendorStatus';
import { vendorStatusSchema } from '../../../../domain/ValidationSchemas/PurchaseOrder/vendorStatus';
import ToastMessage from '../../../../common/ToastMessage';
import CustomDataGrid from '../../../../common/CustomDataGrid';
import useVendorStatus from '../../../../store/ReactQueries/procurements/vendorStatuses/useVendorStatus';
import useAddVendorStatus from '../../../../store/ReactQueries/procurements/vendorStatuses/useAddVendorStatus';
import useUpdateVendorStatus from '../../../../store/ReactQueries/procurements/vendorStatuses/useUpdateVendorStatus';
import useDeleteVendorStatus from '../../../../store/ReactQueries/procurements/vendorStatuses/useDeleteVendorStatus';

export const VendorStatuses = () => {
    const { language } = useLanguageStore();

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [form, setForm] = useState<VendorStatusInterface>({
        id: '',
        title: '',
    });

    const [modal, setModal] = useState<{ add: boolean, edit: boolean, view: boolean }>({
        add: false,
        edit: false,
        view: false
    });

    let { data: vendorStatuses, error: vendorStatusError, isLoading } = useVendorStatus(page, pageSize);

    const addVendorStatus = useAddVendorStatus(page, pageSize);
    const updateVendorStatus = useUpdateVendorStatus(page, pageSize);
    const deleteVendorStatus = useDeleteVendorStatus(page, pageSize);

    useEffect(() => {
        if (vendorStatusError) ToastMessage.Failed(`Error: ${vendorStatusError.message}`);
    }, [vendorStatusError])

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false, width: 150 },
        { field: 'title', headerName: 'Title', type: "string", editable: false, width: 250 },

    ];

    const addItems = () => {
        setForm({
            ...form,
            id: '',
            title: ''
        });
        setModal({ ...modal, add: true });
        setErrors({});
    }

    const handleError = (error: unknown) => {
        if (error instanceof Error) ToastMessage.Failed(error.message);
        else ToastMessage.Failed();
    };

    const handleSave = async () => {
        const isValid = validateSchema(vendorStatusSchema, form);

        setErrors(isValid.errors);
        if (!isValid.result) return;

        const { id, title } = form;

        const upForm: VendorStatusInterface = {
            id,
            title
        };

        if (upForm.id === '') {
            const { id, ...formData } = upForm;
            addVendorStatus.mutate(formData, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        } else {
            updateVendorStatus.mutate(upForm, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        }
        setModal({ ...modal, add: false, edit: false, view: false });
    }

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language['ToastDeleteItem'])) {
            deleteVendorStatus.mutate(id, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        }
    };

    return (
        <CustomDataGrid
            name={language['VendorStatuses']}
            hideColumns={['id']}
            showColumnModal={['title']}
            rows={vendorStatuses || []}
            form={form}
            page={page}
            modal={modal}
            errors={errors}
            columns={columns}
            loading={isLoading}
            pageSize={pageSize}
            setPage={setPage}
            setForm={setForm}
            setModal={setModal}
            addItems={addItems}
            setErrors={setErrors}
            handleSave={handleSave}
            setPageSize={setPageSize}
            handleDelete={handleDelete}
        />
    );
}
export default VendorStatuses;